<template>
	<div class="page_container flex_wrap column j_c_between a_i_center">
		<header class="title">
			<h1>司机流水统计查询</h1>
			<div class="filtrate_wrap flex_wrap wrap">
				<!-- <div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" v-model="dateType">
						<option :value="item.value" v-for="(item, index) in dateSelection" :key="index">{{ item.text }}</option>
					</select>
				</div> -->

				<div class="date_wrap flex_wrap a_i_center j_c_around">
					<input class="date" type="date" v-model="startDate" :min="targetOpenId != '' ? '' : minDate" />
					<span class="">至</span>
					<input class="date" type="date" v-model="endDate" :max="targetOpenId != '' ? '' : maxDate" />
				</div>

				<div class="btn_wrap flex_wrap"><button class="btn demand_btn" @click="getStatisticalList">统计</button></div>

				<!-- <div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" v-model="limitType">
						<option :value="item.value" v-for="(item, index) in limitSelection" :key="index">{{ item.text }}</option>
					</select>
				</div> -->

				<!-- <div class="select_wrap flex_wrap j_c_center a_i_center">
					开始时间
					<input class="date" type="time" v-model="startTime" />
					结束时间
					<input class="date" type="time" v-model="endTime" />
				</div> -->
			</div>
		</header>

		<div class="index_content">
			<h3 v-if="driverStatisticalList && driverStatisticalList.length && driverStatisticalList.length > 0">统计列表</h3>
			<div class="table statistics_table" v-if="driverStatisticalList && driverStatisticalList.length && driverStatisticalList.length > 0">
				<ul class="tr bg_tr flex_wrap">
					<li class="th">日期</li>
					<li class="th">市内</li>
					<li class="th">专车</li>
					<li class="th">总人数</li>
					<li class="th">总流水</li>
				</ul>
				<ul class="tr flex_wrap" v-for="(record, index) in driverStatisticalList" :key="index" @click="getDateOfJobList(record)">
					<li class="td">{{ record.Year + '-' + record.Month + '-' + record.Day }}</li>
					<li class="td">{{ record.ShortCount }}</li>
					<li class="td">{{ record.LongCount }}</li>
					<li class="td">{{ record.MemberCount }}</li>
					<li class="td">{{ record.TotalPrice }}</li>
				</ul>
				<ul class="tr bg_tr flex_wrap">
					<li class="th">合计</li>
					<li class="th">{{ this.TotalShortCount }}</li>
					<li class="th">{{ this.TotalLongCount }}</li>
					<li class="th">{{ this.TotalMemberCount }}</li>
					<li class="th">{{ this.SumTotalPrice }}</li>
				</ul>
			</div>

			<h3 v-if="jobList && jobList.length && jobList.length > 0">订单列表</h3>
			<div class="table statistics_table" v-if="jobList && jobList.length && jobList.length > 0">
				<ul class="tr bg_tr flex_wrap">
					<li class="th">预约时间</li>
					<li class="th">订单类型</li>
					<li class="th">出发地</li>
					<li class="th">目的地</li>
					<li class="th">价格</li>
				</ul>
				<ul class="tr flex_wrap" v-for="(record, index) in jobList" :key="index" @click="customInfo(record)">
					<li class="td">{{ record.bookingDate }}</li>
					<li class="td">{{ orderTypeList[record.OrderType] }}</li>
					<li class="td">{{ record.bookingStartAddr }}</li>
					<li class="td">{{ record.bookingEndAddr }}</li>
					<li class="td">{{ record.TotalPrice }}</li>
				</ul>
				<ul class="tr bg_tr flex_wrap">
					<li class="th"></li>
					<li class="th"></li>
					<li class="th"></li>
					<li class="th"></li>
					<li class="th"></li>
				</ul>
			</div>
		</div>

    <Modal
      v-model="showinfo"
      title="客人信息"
      class='showinfo'>
      <p>下单时间：{{custominfo.CreateDate}}</p>
      <p>下单人：{{custominfo.Contact}}</p>
      <p>下单人电话：{{custominfo.riderPhone}}</p>
      <p>乘大巴人：{{this.busPeople}}</p>
      <p>乘大巴人电话：{{this.busPhone}}</p>
      <p>大巴时间：{{this.busTime}}</p>
      <p>出发地：{{custominfo.bookingStartAddr}}</p>
      <p>目的地：{{custominfo.bookingEndAddr}}</p>
      <div v-if="hisDriverTable == ''" style="font-size:0.38rem;">第一次乘坐接送车！</div>
      <div v-if="hisDriverTable != ''" v-for="(item, index) in hisDriverTable" :key="index" style="border: 1px solid gray;">
        <div style="display: flex;font-size:0.38rem;">
          <div style="border-right: 1px solid gray;width: 50%;">{{item.bookingDate}}</div>
          <div style="width: 50%;">{{item.DriverName}}</div>
        </div>
      </div>
    </Modal>

		<footer class=""></footer>
	</div>
</template>

<script>
import baseTool from '@/utils/baseFunction';
import appointApi from '@/request/appointApi';
import driverApi from '@/request/driverApi';
import { mapState } from 'vuex';
export default {
	name: 'DriverJobStatistical',
	data() {
		return {
			orderTypeList: ['随意约', '车票接送', '长途专车', '市内接送'],
			driverStatisticalList: [],
			jobList: [],
			startDate: '',
			endDate: '',
			currentDate: '',
			TotalLongCount: 0,
			TotalShortCount: 0,
			TotalMemberCount: 0,
			SumTotalPrice: 0,
			maxDate: '',
			minDate: '',
			targetOpenId: '',
      showinfo:false,
      custominfo:[],
      busPeople:'',
      busPhone:'',
      busTime:'',
      hisDriverTable:[],
		};
	},
	activated() {
		this.startDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
		this.endDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
		this.getLimitDate();
		if (this.$route.params.target && this.$route.params.target.length > 0) {
			this.targetOpenId = this.$route.params.target;
		}
	},
	methods: {
		getLimitDate() {
			let tmpMin = new Date(),
				tmpMax = new Date();
			tmpMin.setTime(new Date().getTime() - 31 * 24 * 60 * 60 * 1000);
			tmpMax.setTime(new Date().getTime() + 31 * 24 * 60 * 60 * 1000);
			this.maxDate = baseTool.dateFormat(tmpMax, 'yyyy-MM-dd');;
			this.minDate = baseTool.dateFormat(tmpMin, 'yyyy-MM-dd');;
		},
		getStatisticalList() {
			let that = this;
			this.TotalLongCount = 0;
			this.TotalMemberCount = 0;
			this.TotalShortCount = 0;
			this.SumTotalPrice = 0;
			this.jobList = [];
			driverApi.getDriverStat(this.targetOpenId != '' ? this.targetOpenId : this.OpenId, this.startDate, this.endDate).then(sucRes => {
				if (sucRes.success) {
					this.driverStatisticalList = sucRes.data;
					sucRes.data.forEach(obj => {
						this.TotalLongCount += obj.LongCount;
						this.TotalShortCount += obj.ShortCount;
						this.TotalMemberCount += obj.MemberCount;
						this.SumTotalPrice += obj.TotalPrice;
					});
				} else this.$Message.warning(sucRes.message);
			});
		},
    customInfo(item){
      console.log(item)
      var that = this;
      this.hisDriverTable = [];

      if(item.FromOrderNum != ''){
        appointApi.GetUserHistoryOrderByApp(item.UserID,0,item.FromOrderNum).then(hisBisRes => {
          console.log('车票hisBisRes',hisBisRes)
          this.busPeople = hisBisRes.data.OrderList_InfoList[0].RealName;
          this.busPhone = hisBisRes.data.OrderList_InfoList[0].Mobile;
          this.busTime = hisBisRes.data.OrderList_InfoList[0].OrderList_InfoFrequencyList[0].SetTime.replace("T", "  ");
        })
      }
      else{
        this.busPeople = '无';
        this.busPhone = '无';
        this.busTime = '无';
      }

      appointApi.GetUserHistoryOrderByApp(item.UserID,1,'').then(hisCarRes => {
        console.log('约车hisCarRes',hisCarRes)
        if(hisCarRes.totalCount > 1){
          var nameArr = [];
          for(var i=1;i<=hisCarRes.totalCount-1;i++){
            hisCarRes.data[i].bookingDate = hisCarRes.data[i].bookingDate.replace("T", "  ");
            nameArr.push(hisCarRes.data[i]);
          }
          this.hisDriverTable = nameArr;
          console.log('hisDriverTable',this.hisDriverTable)
        }
        else if(hisCarRes.totalCount == 1){
          this.hisDriverTable = [];
        }
      })

      item.CreateDate = item.CreateDate.replace("T", "  ")
      this.custominfo = item;
      this.showinfo = true;
    },
		getDateOfJobList(statRecord) {
			let that = this;
			this.currentDate = statRecord.Year + '-' + statRecord.Month + '-' + statRecord.Day;
			driverApi.getJobList(this.targetOpenId != '' ? this.targetOpenId : this.OpenId, this.currentDate).then(sucRes => {
				if (sucRes.success) {
					this.jobList = sucRes.data;
				} else this.$Message.warning(sucRes.message);
			});
		}
	},
	computed: mapState({
		OpenId: state => state.user.OpenId
		// OpenId: state => 'oDcOv532-NFdzWgPZkmKHt5WySDo'
    // OpenId: state => 'oDcOv5z4gqoMXQJ3HPgboGOgUFPg'
	})
};
</script>

<style scoped="scoped" type="text/css">
.title {
	width: 100%;
	background-color: #005242;
	text-align: center;
}
.title h1 {
	width: 100%;
	line-height: 10vh;
	color: #fff;
	font-size: 0.5rem;
}
.filtrate_wrap {
	width: 100%;
	border-top: 5px solid #f8f8f8;
	padding: 0.2rem 0;
}
.filtrate_wrap > div {
	margin: 0.2rem 0 0.2rem 0.3rem;
}
.select_wrap,
.date_wrap,
.btn_wrap {
	align-self: stretch;
	height: 4vh;
	position: relative;
}
.select,
.date {
	box-sizing: border-box;
	align-self: stretch;
	background-color: #555;
	font-size: 0.35rem;
	outline: none;
	color: #fff;
	border: 1px solid #888;
}

.select {
	width: 100%;
}

.date_wrap > span {
	margin: 0 0.2rem;
	color: #fff;
}
.demand_btn {
	background-color: #f8f8f8;
	color: #333;
}
.demand_btn:active {
	background-color: #ddd;
	color: #555;
}

.index_content {
	width: 100%;
	flex: 1;
	padding: 0.2rem;
	overflow-y: scroll;
}
.table {
}
.bg_tr {
	background-color: #888;
}
.tr {
	color: #fff;
}
.td {
	color: #888;
}
.statistics_table .tr:last-child .td {
	color: #fff;
}
.bg_huizong {
	background-color: #2fdab9;
}

.tong_ji {
	border-bottom: 1px solid #888;
}
.index_content h3:nth-child(n + 2) {
	margin-top: 0.2rem;
}
.index_content h3 {
	text-align: center;
	color: #fff;
	line-height: 4vh;
	background-color: #06967a;
}

body,
ol,
ul,
h1,
h2,
h3,
h4,
h5,
h6,
p,
th,
td,
dl,
dd,
form,
fieldset,
legend,
input,
textarea,
select {
	margin: 0;
	padding: 0;
}
body {
	font: 12px/24px '微软雅黑', 'Arial Narrow', HELVETICA;
	-webkit-text-size-adjust: 100%;
}
a {
	color: #2d374b;
	text-decoration: none;
}
a:hover {
	color: #cd0200;
	text-decoration: underline;
}
em {
	font-style: normal;
}
li {
	list-style: none;
}
button,
input {
	outline: none;
}
img {
	border: 0;
	vertical-align: middle;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
div {
	box-sizing: border-box;
}
p {
	word-wrap: break-word;
}

html {
	height: 100%;
}

body {
	margin: 0 auto;
	width: 10rem;
	height: 100%;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
}
.page_container {
	width: 100%;
	height: 100%;
	margin: 0 auto;
}
.flex_wrap {
	display: flex;
}
.row {
	flex-direction: row;
}
.column {
	flex-direction: column;
}
.wrap {
	flex-wrap: wrap;
}
.j_c_center {
	justify-content: center;
}
.j_c_start {
	justify-content: flex-start;
}
.j_c_end {
	justify-content: flex-end;
}
.j_c_around {
	justify-content: space-around;
}
.j_c_between {
	justify-content: space-between;
}
.a_i_center {
	align-items: center;
}
.a_i_start {
	align-items: flex-start;
}
.a_i_end {
	align-items: flex-end;
}

.btn {
	outline: none;
	border: 1px solid #888;
	border-radius: 4px;
}

.table {
	width: 100%;
	border: 1px solid #aaa;
}
.table:nth-child(n + 2) {
	margin-top: 0.2rem;
}
.tr {
	justify-content: space-around;
	align-items: center;
	flex: 1;
}
.th:nth-last-child(n + 2),
.td:nth-last-child(n + 2) {
	border-right: 1px solid #ddd;
}
.tr:nth-last-child(n + 2) {
	border-bottom: 1px solid #ddd;
}
.th,
.td {
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	flex-wrap: wrap;
	word-break: break-all;
	text-align: center;
}
.td {
	padding: 0.1rem;
}

@font-face {
	font-family: 'iconfont';
	src: url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.eot');
	src: url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.woff') format('woff'),
		url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.ttf') format('truetype'), url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.svg#iconfont') format('svg');
}
.iconfont {
	font-family: 'iconfont' !important;
	/*font-size:40rpx;*/
	margin: 0 5px;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.iconreversal {
	transition: all 0.3s;
	display: inline-block;
	transform: scaleY(-1);
}
.noticonreversal {
	transition: all 0.3s;
	display: inline-block;
	transform: scaleY(1);
}
</style>



// WEBPACK FOOTER //
// src/components/DriverJobStatistical.vue